import { useEffect } from "react";
import usePageSeo from "../hooks/usePageSeo";

const WEB = "https://azzirevents.com";
const PLAY = "https://play.google.com/store/apps/details?id=com.azzir";
const APP_STORE = "https://apps.apple.com/app/id6449482277";

const GET_SEO = {
  title: "Opening Azzir… | Azzir Events",
  noindex: true,
  canonicalPath: "/get",
};

function launchGetApp() {
  const ua = navigator.userAgent || "";
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) && !/Macintosh/i.test(ua);
  if (!isAndroid && !isIOS) return "desktop";

  window.__AZZIR_GET_LAUNCHED = true;

  let left = false;
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) left = true;
  });
  window.addEventListener("pagehide", function () {
    left = true;
  });

  if (isAndroid) {
    window.location.href = "azzir://get";
    window.setTimeout(function () {
      if (left) return;
      window.location.href =
        "intent://get#Intent;scheme=https;host=azzirevents.com;package=com.azzir;end";
    }, 300);
    window.setTimeout(function () {
      if (!left) window.location.href = PLAY;
    }, 1000);
    return "mobile";
  }

  window.location.href = "azzir://get";
  window.setTimeout(function () {
    if (!left) window.location.href = APP_STORE;
  }, 1000);
  return "mobile";
}

const GetApp = () => {
  usePageSeo(GET_SEO);

  useEffect(() => {
    if (window.__AZZIR_GET_LAUNCHED) return;
    const kind = launchGetApp();
    if (kind === "desktop") {
      window.location.replace(WEB);
    }
  }, []);

  return <p className="azzir-open-app">Opening Azzir…</p>;
};

export default GetApp;
